import React from 'react'

export default function Root() {
    window.location.href = '/standard';
    return (
    <div></div>
    )
}
